import Mutations from '../../odata/mutations';

export default { ...new Mutations('checklistTemplate'), ...new Mutations('checklistTemplates') };
